<div class="pricing-results-display" (click)="toggleShowMid()">
  <!-- Title row -->
  <div class="results-row-multiple-values">
    <div
      *ngIf="!showMid"
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      {{ pricedLeg?.pricing?.headers.bid }}
    </div>
    <div
      *ngIf="!showMid"
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      {{ pricedLeg?.pricing?.headers.ask }}
    </div>

    <div class="results-row-multiple-values__mid-column-value" *ngIf="showMid">
      {{ pricedLeg?.pricing?.headers.mid }}
    </div>
  </div>

  <!-- do not hide premiumQuoteCurrency -->
  <div
    *ngIf="!pricedLeg?.pricing?.price?.premiumCurrency"
    class="results-row-multiple-values"
  >
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.bid !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.bid !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.bid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.bid | number: '1.0-0'
        }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.mid !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.mid !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.mid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.mid | number: '1.0-0'
        }}
      </ng-container>
    </div>
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.ask !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.ask !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.ask !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrency?.ask | number: '1.0-0'
        }}
      </ng-container>
    </div>
  </div>

  <!-- do not hide premiumCurrency bid/mid/ask  -->
  <div
    *ngIf="pricingResultsExpanded && pricedLeg.pricing?.price.premiumCurrency"
    class="results-row-multiple-values"
  >
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumCurrency?.bid !== null &&
          pricedLeg?.pricing?.price?.premiumCurrency?.bid !== '' &&
          pricedLeg?.pricing?.price?.premiumCurrency?.bid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{ pricedLeg?.pricing?.price?.premiumCurrency?.bid | number: '1.0-0' }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumCurrency?.mid !== null &&
          pricedLeg?.pricing?.price?.premiumCurrency?.mid !== '' &&
          pricedLeg?.pricing?.price?.premiumCurrency?.mid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{ pricedLeg?.pricing?.price?.premiumCurrency?.mid | number: '1.0-0' }}
      </ng-container>
    </div>
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumCurrency?.ask !== null &&
          pricedLeg?.pricing?.price?.premiumCurrency?.ask !== '' &&
          pricedLeg?.pricing?.price?.premiumCurrency?.ask !== undefined
        "
      >
        {{ quoteCurrency }}
        {{ pricedLeg?.pricing?.price?.premiumCurrency?.ask | number: '1.0-0' }}
      </ng-container>
    </div>
  </div>

  <!-- premiumQuoteCurrencyInPercent -->
  <div
    *ngIf="
      pricingResultsExpanded && isRowEnabled('premiumQuoteCurrencyInPercent')
    "
    class="results-row-multiple-values"
  >
    <div
      *ngIf="
        !showMid &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !==
          null &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !== '' &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !==
          undefined
      "
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !==
            null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !==
            '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid !==
            undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.bid
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.mid !==
            null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.mid !==
            '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.mid !==
            undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.mid
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
    <div
      *ngIf="
        !showMid &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !==
          null &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !== '' &&
        pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !==
          undefined
      "
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !==
            null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !==
            '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask !==
            undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyInPercent?.ask
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
  </div>

  <!-- premiumQuoteCurrencyPips -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('premiumQuoteCurrencyPips')"
    class="results-row-multiple-values"
  >
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.bid !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.bid !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.bid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.bid
            | number: '1.2-2'
        }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.mid !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.mid !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.mid !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.mid
            | number: '1.2-2'
        }}
      </ng-container>
    </div>
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.ask !== null &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.ask !== '' &&
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.ask !== undefined
        "
      >
        {{ quoteCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumQuoteCurrencyPips?.ask
            | number: '1.2-2'
        }}
      </ng-container>
    </div>
  </div>

  <!-- premiumBaseCurrency -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('premiumBaseCurrency')"
    class="results-row-multiple-values"
  >
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.bid !== null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.bid !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.bid !== undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.bid | number: '1.0-0'
        }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.mid !== null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.mid !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.mid !== undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.mid | number: '1.0-0'
        }}</ng-container
      >
    </div>
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.ask !== null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.ask !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.ask !== undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrency?.ask | number: '1.0-0'
        }}</ng-container
      >
    </div>
  </div>

  <!-- premiumBaseCurrencyInPercent -->
  <div
    *ngIf="
      pricingResultsExpanded && isRowEnabled('premiumBaseCurrencyInPercent')
    "
    class="results-row-multiple-values"
  >
    <div
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--bid': isBidActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.bid !==
            null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.bid !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.bid !==
            undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.bid
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
    <div class="results-row-multiple-values__mid-column-value">
      <ng-container
        *ngIf="
          showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.mid !==
            null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.mid !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.mid !==
            undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.mid
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
    <div
      *ngIf="
        !showMid &&
        pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !== null &&
        pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !== '' &&
        pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !==
          undefined
      "
      class="results-row-multiple-values__value"
      [ngClass]="{
        'results-row-multiple-values__value--ask': isAskActive
      }"
    >
      <ng-container
        *ngIf="
          !showMid &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !==
            null &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !== '' &&
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask !==
            undefined
        "
      >
        {{ baseCurrency }}
        {{
          pricedLeg?.pricing?.price?.premiumBaseCurrencyInPercent?.ask
            | percent: '1.4-4'
        }}
      </ng-container>
    </div>
  </div>

  <!-- upfrontPremiumBsMid  -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('upfrontPremiumBsMid')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.price?.pvQuoteCurrency?.bsMid !== null &&
        pricedLeg?.pricing?.price?.pvQuoteCurrency?.bsMid !== '' &&
        pricedLeg?.pricing?.price?.pvQuoteCurrency?.bsMid !== undefined
      "
    >
      {{ quoteCurrency }}
      {{ pricedLeg?.pricing?.price?.pvQuoteCurrency?.bsMid | number: '1.0-0' }}
    </div>
  </div>

  <!-- spotDelta -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('spotDelta')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.spotDeltas &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>

  <!-- spotDeltaPercent -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('spotDeltaPercent')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.spotDeltas &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrencyInPercent !== null &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrencyInPercent !== '' &&
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrencyInPercent !== undefined
      "
    >
      {{
        (pricedLeg?.pricing?.spotDeltas)[0]?.baseCurrencyInPercent
          | percent: '1.2-2'
      }}
    </div>
  </div>

  <!-- forwardDelta -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('forwardDelta')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.forwardDeltas &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrency | number: '1.0-0'
      }}
    </div>
  </div>

  <!-- forwardDeltaPercent -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('forwardDeltaPercent')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.forwardDeltas &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrencyInPercent !==
          null &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrencyInPercent !== '' &&
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrencyInPercent !==
          undefined
      "
    >
      {{
        (pricedLeg?.pricing?.forwardDeltas)[0]?.baseCurrencyInPercent
          | percent: '1.2-2'
      }}
    </div>
  </div>

  <!-- brokerDelta -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('brokerDelta')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.brokerDeltas &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrency | number: '1.0-0'
      }}
    </div>
  </div>

  <!-- brokerDeltaPercent -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('brokerDeltaPercent')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.brokerDeltas &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrencyInPercent !== null &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrencyInPercent !== '' &&
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrencyInPercent !==
          undefined
      "
    >
      {{
        (pricedLeg?.pricing?.brokerDeltas)[0]?.baseCurrencyInPercent
          | percent: '1.2-2'
      }}
    </div>
  </div>

  <!-- gamma -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('gamma')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.gammas &&
        (pricedLeg?.pricing?.gammas)[0]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.gammas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.gammas)[0]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.gammas)[0]?.baseCurrency | number: '1.0-0' }}
    </div>
  </div>

  <!-- vega -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('vega')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.vegas &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== null &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== '' &&
        (pricedLeg?.pricing?.vegas)[0]?.baseCurrency !== undefined
      "
    >
      {{ baseCurrency }}
      {{ (pricedLeg?.pricing?.vegas)[0]?.baseCurrency | number: '1.2-2' }}
    </div>
  </div>

  <!-- riskies  -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('riskies')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.riskies &&
        (pricedLeg?.pricing?.riskies)[0]?.quoteCurrency !== null &&
        (pricedLeg?.pricing?.riskies)[0]?.quoteCurrency !== '' &&
        (pricedLeg?.pricing?.riskies)[0]?.quoteCurrency !== undefined
      "
    >
      {{ quoteCurrency }}
      {{ (pricedLeg?.pricing?.riskies)[0]?.quoteCurrency | number: '1.2-2' }}
    </div>
  </div>

  <!-- flies  -->
  <div
    *ngIf="pricingResultsExpanded && isRowEnabled('flies')"
    class="results-row"
  >
    <div
      class="center-text"
      *ngIf="
        pricedLeg?.pricing?.flies &&
        (pricedLeg?.pricing?.flies)[0]?.quoteCurrency !== null &&
        (pricedLeg?.pricing?.flies)[0]?.quoteCurrency !== '' &&
        (pricedLeg?.pricing?.flies)[0]?.quoteCurrency !== undefined
      "
    >
      {{ quoteCurrency }}
      {{ (pricedLeg?.pricing?.flies)[0]?.quoteCurrency | number: '1.2-2' }}
    </div>
  </div>
</div>
